import React from 'react';

/**
 * SquareLegend — Reusable legend for square game boards.
 * 
 * Shows color-coded status swatches: Available · Taken · Your Square · Reserved · Winner (optional)
 * 
 * @param {Object} props
 * @param {boolean} [props.showWinner=false] - Whether to include the Winner swatch
 * @param {string} [props.className] - Additional CSS classes
 */
export default function SquareLegend({ showWinner = false, className = '' }) {
  return (
    <div className={`mt-3 flex flex-wrap gap-3 justify-center text-[11px] text-gray-600 dark:text-gray-400 ${className}`}>
      <span className="flex items-center gap-1">
        <span className="w-3 h-3 rounded border-2 border-emerald-400/30 bg-emerald-500/20 inline-block" />
        Available
      </span>
      <span className="flex items-center gap-1">
        <span className="w-3 h-3 rounded border-2 border-slate-500 bg-slate-600/60 inline-block" />
        Taken
      </span>
      <span className="flex items-center gap-1">
        <span className="w-3 h-3 rounded border-2 border-blue-400 bg-blue-500/30 inline-block" />
        Your Square
      </span>
      <span className="flex items-center gap-1">
        <span className="w-3 h-3 rounded border-2 border-amber-400/60 bg-amber-500/15 inline-block" />
        Reserved
      </span>
      {showWinner && (
        <span className="flex items-center gap-1">
          <span className="w-3 h-3 rounded border-2 border-yellow-400 bg-yellow-500/30 inline-block" />
          Winner 🏆
        </span>
      )}
    </div>
  );
}
